import { Component, OnInit,EventEmitter,Output } from '@angular/core';
import { stretch } from '@amcharts/amcharts4/.internal/core/utils/Math';
import{LeftAsideService} from 'src/app/leftAside/left-aside.service'
import { InteractionService } from '../interaction.service';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../Services/auth.service';
import { TokenService } from '../Services/token.service';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { AppDataServiceService } from '../app-data-service.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
/*
  myFilter = (d: Date): boolean => {
    const day = d.getDay();
    // Prevent Saturday and Sunday from being selected.
    return day !== 0 && day !== 6;
  }*/
  public loggedIn : boolean;
  model: NgbDateStruct;
  sideBarStatus:boolean=true;
  data:any;
  date ;
  time ;
  temperature ;
  humidity;
  @Output() 
  sendData:EventEmitter<boolean> =  new EventEmitter<boolean>(); 
  statusEnergy :boolean = true;
  statusProductivity :boolean = false;
  constructor(
    private LeftAsideServiceobj:LeftAsideService,private _interactionService:InteractionService,
    private auth:AuthService,
    private token:TokenService,
    private router:Router,
    public appComponent:AppComponent,
    public getweather: AppDataServiceService
  ) { 
    this.LeftAsideServiceobj.setHeaderDataMethodCalled$.subscribe(
      (data) => {
        this.setHeader(data);

      }
    );
  }

  ngOnInit() {
    let data;
    this.auth.authStatus.subscribe(value => this.loggedIn = value)
    
    console.log("jay");
    console.log(data);
  }
  logout(event:MouseEvent){
    event.preventDefault();
    this.auth.changeAuthStatus(false);
    this.token.remove();
    this.router.navigateByUrl('/login');
  }


  showProduction(data){
    this._interactionService.sendMessage("gm");
    this.statusEnergy = false;
    this.statusProductivity = data
    this.sendData.emit(true);
   }
  showEnergy(data){
    this.statusEnergy=data;
    this.statusProductivity = false
    this.sendData.emit(false);
  }
  
  setHeader(data){
    console.log('header ',data);
    //this.model = data.data.date;
    var date = new Date(data.data.date);
    console.log('date ',date);
    console.log('date ',date.getDate());

    this.model  = { day: date.getDate(), month: date.getMonth()+1, year: date.getFullYear()};
    console.log('model ',this.model );
    
    this.time = data.data.time;;
    /*this.temperature = "18 ";
    this.humidity = "35";*/
    this.getweather.getWeatherData().subscribe(weather_data => this.setTemperatur(weather_data))
  }
  setTemperatur(weather_data){
    this.temperature = weather_data.data[0].Temperature;
    this.humidity = weather_data.data[0].RelativeHumidity;
  }
  showSideBar(status){
    console.log(status);
    if(status==true){this.sideBarStatus = !status;}
    else{this.sideBarStatus = !status;}
    
  }




}
